var _path, _path2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoskillset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.16,303.59c.88-7.24-2.53-22.88-8.89-33.19s-17.34-18.64-26.08-16.79c-8.15,1.72-8.55,12.08.1,20s21.87,18.22,24.61,30.47l7,15.48Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.16,303.59c.88-7.24-2.53-22.88-8.89-33.19s-17.34-18.64-26.08-16.79c-8.15,1.72-8.55,12.08.1,20s21.87,18.22,24.61,30.47l7,15.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.48,313.56a.53.53,0,0,1-.42-.48c-1.84-25.31-19.38-47.84-30.8-53.73a.53.53,0,0,1-.23-.72.53.53,0,0,1,.72-.23c11.64,6,29.51,28.91,31.37,54.6a.54.54,0,0,1-.49.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,328.93c-.67-4.21-4.82-11.53-12.18-18.06-8.15-7.22-19.06-11.42-21.07-16.51-2.42-6.12,3.08-10.95,12.08-8.7s23.54,16.67,23.82,35.75Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.16,324.87a.54.54,0,0,1-.42-.4c-5-22.1-20.24-31.5-27.6-33.38a.54.54,0,0,1-.39-.65.53.53,0,0,1,.65-.39c8.14,2.09,23.28,11.63,28.38,34.18a.52.52,0,0,1-.4.64A.41.41,0,0,1,54.16,324.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.36,304.79s-.85-13.12,3.74-24.25,12.26-18.93,20.34-21.06,16.06,4.23,8.22,11S452.2,285.32,448.51,306Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.36,304.79s-.85-13.12,3.74-24.25,12.26-18.93,20.34-21.06,16.06,4.23,8.22,11S452.2,285.32,448.51,306Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M444.16,301h-.09a.45.45,0,0,1-.34-.53c4.81-22.86,19.67-34.72,26.86-37.8a.45.45,0,1,1,.35.82c-7,3-21.61,14.66-26.34,37.16A.46.46,0,0,1,444.16,301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.93,289.76c-.4,1.71-2,2.86-3.44,3.81s-3.08,2-3.66,3.62c-1.17,3.34,2.5,7,1.19,10.32a5.48,5.48,0,0,1-3.27,2.83,36,36,0,0,1-3.55,1,15.13,15.13,0,0,1-1.75.2,7.88,7.88,0,0,0-4.87,1.48c-2.14,1.8-2.3,5-3.3,7.57a11.57,11.57,0,0,1-7.09,6.59c-2.65.87-6.83,1-7.76,0-.7-.82.36-3.87.19-4.93a43.72,43.72,0,0,1-.51-8.24,15.74,15.74,0,0,0-.18-3.76c-.28-1.38-.54-2.77-.8-4.16s-.85-2.61-.6-4.22a15.55,15.55,0,0,1,1.59-4.38c.68-1.38,1.36-2.75,2.06-4.12a21.69,21.69,0,0,1,2.88-4.58,11.53,11.53,0,0,1,8.3-3.87c2.6-.06,5.33.89,7.91.27s4.85-1.75,7.47-2.06a9.18,9.18,0,0,1,7.69,2.31A4.88,4.88,0,0,1,483.93,289.76Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.38,320h0a.39.39,0,0,1-.36-.42c1.78-24.76,26-32.91,31.85-33.6a.41.41,0,0,1,.44.35.39.39,0,0,1-.35.43c-5.76.68-29.41,8.65-31.15,32.88A.41.41,0,0,1,447.38,320Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.68,302.81a.44.44,0,0,1-.22-.07,21,21,0,0,0-17.81-1.54.39.39,0,0,1-.5-.24.4.4,0,0,1,.24-.5,21.76,21.76,0,0,1,18.51,1.63.39.39,0,0,1-.22.72Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pie-chart--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pie-chart--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.13,275.24l-89.75-51.81c38-21.66,97.65-28.14,146.85-13.61,60.78,18,90.19,63.87,60.88,99.64Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.13 275.24 250.13 346.73 368.11 380.94 368.11 309.46 250.13 275.24",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.13 275.24 250.13 346.73 368.11 380.94 368.11 309.46 250.13 275.24",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.38 223.43 160.38 294.91 250.13 346.73 250.13 275.24 160.38 223.43",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.38 223.43 160.38 294.91 250.13 346.73 250.13 275.24 160.38 223.43",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.11,380.94c7.8-9.52,11.44-19.76,11.44-30V279.46c0,10.24-3.64,20.48-11.44,30Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.11,380.94c7.8-9.52,11.44-19.76,11.44-30V279.46c0,10.24-3.64,20.48-11.44,30Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,341.54a177.64,177.64,0,0,1-29.74,13.52l-51.44-58.33L362.06,326.4A91.48,91.48,0,0,1,342.29,341.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.11 296.73 261.11 358.37 312.55 416.69 312.55 355.06 261.11 296.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,416.69a176.85,176.85,0,0,0,29.74-13.52A91.48,91.48,0,0,0,362.06,388V326.4a91.48,91.48,0,0,1-19.77,15.14,177.64,177.64,0,0,1-29.74,13.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,375.09c-9.72-3.19-17.66-7.86-26-12.58-42.24-24-49-73.19-4.64-101.57l86.94,49.95Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,375.09c-9.72-3.19-17.66-7.86-26-12.58-42.24-24-49-73.19-4.64-101.57l86.94,49.95Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.35 310.89 182.02 375.09 182.02 414.72 238.35 350.52 238.35 310.89",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.35 310.89 182.02 375.09 182.02 414.72 238.35 350.52 238.35 310.89",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,414.72c-9.72-3.19-17.66-7.86-26-12.58-22.5-12.78-34.94-32.71-34.94-52.83V309.46c0,20.12,12.44,40.05,34.94,52.83,8.31,4.72,16.25,9.39,26,12.58Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,414.72c-9.72-3.19-17.66-7.86-26-12.58-22.5-12.78-34.94-32.71-34.94-52.83V309.46c0,20.12,12.44,40.05,34.94,52.83,8.31,4.72,16.25,9.39,26,12.58Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,392.72C267.48,402,226.61,400.28,193,391l53.28-60.28Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,392.72C267.48,402,226.61,400.28,193,391l53.28-60.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,418.33c33.62,9.27,74.49,11,108,1.71V392.72C267.48,402,226.61,400.28,193,391Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,418.33c33.62,9.27,74.49,11,108,1.71V392.72C267.48,402,226.61,400.28,193,391Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.66,152.55c.47.49,1,1,1.45,1.44.66.63,2,1.64,2.68,2.27.2.19,1,.7,1.06.92a14.3,14.3,0,0,1-.78-3.37,2.08,2.08,0,0,1,1.62-2.31c.45-.05.48,1.08,1.42,2.65,1.2,2,2.75,3,3.47,5.48a4.44,4.44,0,0,0,2.32,2.46l18.66,9.27s13.64-5.06,20.71-7.83c8.21-3.22,17.61-6.28,19.19-4.6l-15.69,14.18s-11.94,6.47-21.24,10.17c-3.13,1.25-4.87.8-7.4-.9a172,172,0,0,1-15.9-10.51,105.11,105.11,0,0,0-10.15-6.56c-2.71-1.52-5.87-3.56-7.14-6.54a6.28,6.28,0,0,1-.06-5.16,6.5,6.5,0,0,0,.9-2,9.5,9.5,0,0,0-.06-1.3,1.34,1.34,0,0,1,.46-1.16,1.18,1.18,0,0,1,1.23,0,3.61,3.61,0,0,1,.94.89C344.09,150.88,344.86,151.73,345.66,152.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17,158.17c-7-1-10.58,1.13-15.4,3.13-5.74,2.37-24.22,9.54-24.22,9.54l-11.92-5.62s-2.74,6.19-5.69,8.71c0,0,10.71,7.59,13.69,9.44s3.15,1.75,7.83.22,25.83-6.93,25.83-6.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.63,165.22l-6.29-2.91s-2.69,5.33-5,7.61l5.6,4a15.12,15.12,0,0,0,3.52-4.2A18.59,18.59,0,0,0,365.63,165.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.56,329.39c-2.43,1.4-5.17,1.37-8.15.24l-2-16,9.68,1Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.7,320.69c-2,4.57-5.76,3.43-10.1.67l.27-16.13,10.24-.31Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,345.09a3.81,3.81,0,0,0,.18,2.48c.34.49,2.23,2,5.58,2.15,3.2.14,6-.38,7.88-1.63a5.5,5.5,0,0,0,2.83-4.41c.12-1.82-.13-3.57.69-5s2-2.82,2.26-3.52a7.19,7.19,0,0,0-.09-3.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.25,329a9,9,0,0,1-.33,2,21.3,21.3,0,0,1-3.11,6c-.94,1.17-2.11,2.15-3.1,3.29a6.53,6.53,0,0,0-1.85,4c-.06,2.51,2.68,3.28,4.78,3.59a15.44,15.44,0,0,0,6.79-.54,6.24,6.24,0,0,0,4.44-5.13c.09-.7,0-1.41.09-2.11a9.81,9.81,0,0,1,1.82-4.44,13.42,13.42,0,0,0,1.42-2.43c.61-1.57,0-3.29-.43-4.83-.4-1.32-.86-2.82-1.32-2.68a1.85,1.85,0,0,1-.09.81,3.38,3.38,0,0,0-.34.8,6.36,6.36,0,0,1-.35,1,2.77,2.77,0,0,1-1.08,1.26l-.18-2.83a1.27,1.27,0,0,0-.24-.83,1.3,1.3,0,0,0-.81-.32,17.66,17.66,0,0,0-5.37-.29,1,1,0,0,0-.71.34,1.06,1.06,0,0,0-.1.64C439.23,327.19,439.29,328.08,439.25,329Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.76,335.58c.91-.72,3-.79,4.15-.71a7,7,0,0,1,3.28,1.05.73.73,0,0,0,.95-.11h0a.69.69,0,0,0-.1-1.06,7.08,7.08,0,0,0-3.69-1.24c-2.82-.12-3.63.39-3.63.39S436.46,334.76,436.76,335.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.69,338.21c1.15-.72,3.46-.69,4.6-.6a6.6,6.6,0,0,1,3.2,1.1.73.73,0,0,0,.95-.1h0a.69.69,0,0,0-.1-1.06,7.3,7.3,0,0,0-3.78-1.35c-2.82-.12-3.53.48-3.53.48A2.33,2.33,0,0,0,434.69,338.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.38,330.78a7,7,0,0,0-3.52.4c-.49.3-.79,1.09-.47,1.28a6.45,6.45,0,0,1,3.12-.53,9.51,9.51,0,0,1,3.07.75c.24.1.53.24.79.37a.66.66,0,0,0,.91-.31h0a.62.62,0,0,0-.27-.8A9.06,9.06,0,0,0,442.38,330.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.12,331.79a3,3,0,0,0,.19,2.23c.33.64,3.8,2.46,8.38,2a19.22,19.22,0,0,0,9.41-3.6c1.71-1.21,3.53-1.49,5.8-1.68s5.23-1.43,5.69-2.5a5,5,0,0,0-.16-2.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.17,317.11l-1.21-.4a1,1,0,0,0-.68-.06c-.29.12-.4.47-.47.78a11.24,11.24,0,0,1-.44,2,5,5,0,0,1-1.25,1.39,20.74,20.74,0,0,1-3.6,2.48c-1.48.85-2.93,1.52-4.46,2.26s-3.65,1.26-4.86,2.13a3.31,3.31,0,0,0,.18,5.47c1.81,1,6.5,2,11.35.45,2.64-.84,5.52-3.77,9-4.15,2.22-.24,6.41-1,7.79-2.72.51-.76-.27-3.12-.91-5.15-.7-2.22-1.05-5.71-1.78-5.49,0,.75-.66,1.2-1,1.83a12.89,12.89,0,0,0-.75,1.8,3.24,3.24,0,0,1-1.11,1.57,1.5,1.5,0,0,1-1.81-.05c-.67-.66-.32-1.86-.82-2.66a2.89,2.89,0,0,0-1.6-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.56,322a2.06,2.06,0,0,1,1.61-1.15,5.94,5.94,0,0,1,3.95,1.36.82.82,0,0,1-.08,1.37h0a.81.81,0,0,1-1-.08A6.35,6.35,0,0,0,404.56,322Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.47,323.89a2.4,2.4,0,0,1,1.92-1.06,7.34,7.34,0,0,1,4.32,1.47.81.81,0,0,1-.07,1.33h0a.78.78,0,0,1-.91-.08A6.38,6.38,0,0,0,401.47,323.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.06,325.57a2.66,2.66,0,0,1,2-1,7.15,7.15,0,0,1,4.15,1.49.81.81,0,0,1-.07,1.33h0a.8.8,0,0,1-.92-.08A6.1,6.1,0,0,0,398.06,325.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.79,212.44c1.1,17.52,2.88,56.17,2.88,56.17.25,2.18,1.06,7.41,1.45,15.27.58,11.39-.32,36.53-.32,36.53a12.32,12.32,0,0,1-9.73.77s-6.48-35.86-8.55-47c-1.82-9.83-5.37-28.34-5.37-28.34l-1.66,23.95a78.25,78.25,0,0,1-.39,14.47c-.65,5.19-3.78,27.75-3.78,27.75a20.58,20.58,0,0,1-11,.08s-1-36.81-1.24-41.59c-.27-5.46-1.41-61.54-1.41-61.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.15,245.8l-3-14.3s-7.21-.41-11.3-4.3c0,0,.82,3.91,9.93,6l3,14.46.3,13.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.49,160.29c3.44.61,3.67,2.32,4.42,5.73a28.21,28.21,0,0,1,.88,8.4l-2.57,20.19.88,23.26c-5.54,6-27.7,8-39.81-.87,0,0,.14-38.21.69-44.34,1-10.72,5.84-14.52,13-14.5l12.19,1Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6,133.21a10.83,10.83,0,1,1-10.79-10.86A10.82,10.82,0,0,1,428.6,133.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,135.33l2.31-6.21a4,4,0,0,1,3.36,1.2c1.44,1.48.61,6.09-1.2,10.61,0,0-1.78,8.24-2.49,9.59a3.74,3.74,0,0,1-2.16,1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,141.3c.67.4,1.61-.87,2.43-1.72s3.5-2,4.82.8-1.2,6.62-3.3,7.27c-3.62,1.13-4.16-1.19-4.16-1.19l-.32,13a11.63,11.63,0,0,1-8.81,6.63c-6.42.85-5.08-4.43-3-7l0-4a22.41,22.41,0,0,1-4.88.23c-2.66-.42-4.33-2.52-5.12-5.41-1.28-4.63-1.76-8.37-.63-17.46,1.24-10,12.84-10,19.09-6.07S432.16,141.3,432.16,141.3Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.1,142.18c1-.3,1.81-2,2.49-2.6,1.15-1-.29-10.46-.29-10.46a4.44,4.44,0,0,0-1.09-4.76c-1.56-1.73-4.17-1.93-8.64-2.65-2.2-.35-4.8-.53-7-.93a22.08,22.08,0,0,1-6.49-2.08,2,2,0,0,0-1.24-.32,1.16,1.16,0,0,0-.78.65,2.14,2.14,0,0,0-.18,1,4,4,0,0,0,.18,1.09c.07.21.5.84.41,1-.23.45-1.94-.31-2.29-.42a.43.43,0,0,0-.25,0,.44.44,0,0,0-.14.16,4.19,4.19,0,0,0,.2,3.62,12.22,12.22,0,0,0,6.15,5.23,17,17,0,0,0,8.38,1.17,16.38,16.38,0,0,0,3.57-.83,8.68,8.68,0,0,0,.78,1.22,5.58,5.58,0,0,0,1.16,1,4.77,4.77,0,0,0,1.39.65c.51.14,1,.07,1.28.62a2.64,2.64,0,0,1,.21,1.15c0,1.16.07,2.31.1,3.46a5.94,5.94,0,0,0,.23,1.74,1.9,1.9,0,0,0,1.17,1.22A1.18,1.18,0,0,0,432.1,142.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,155.15s5.95-1.18,8-2.27a7,7,0,0,0,2.88-2.83,9.37,9.37,0,0,1-1.65,3.34c-1.52,1.94-9.26,3.34-9.26,3.34Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76,139.5a1.19,1.19,0,1,0,1.19-1.23A1.21,1.21,0,0,0,420.76,139.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.18,135.84l2.64,1.71a1.65,1.65,0,0,0-.49-2.23A1.53,1.53,0,0,0,422.18,135.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,146.74l-4.19,1.79a2.32,2.32,0,0,0,3.08,1.22A2.2,2.2,0,0,0,422.74,146.74Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.84,137.13l2.51-1.52a1.41,1.41,0,0,0-2-.53A1.55,1.55,0,0,0,409.84,137.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.83,139.13a1.2,1.2,0,0,0,1.18,1.24,1.23,1.23,0,0,0,1.2-1.24,1.19,1.19,0,1,0-2.38,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.46 138.49 416.44 146.09 412.57 144.42 417.46 138.49",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,220.61l.17,3.37a1.23,1.23,0,0,0,1.09,1.16,25.35,25.35,0,0,0,11.65-1.49c7-2.61,7.13-4.85,7.13-4.85l0-4.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,217.21v2.6a.81.81,0,0,1-1.05.77,15.08,15.08,0,0,1-2.88-1.18,6.52,6.52,0,0,1-2.11-1.71l-.13-3.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.89,213.75c1.46,2.36,6.17,3.46,6.17,3.46s-.11-1.7,0-11,.45-26.62,2.49-34.36a41.32,41.32,0,0,1,5.42-12,2.68,2.68,0,0,1,2-1.19v-.45c-7-.11-8.64.6-11.61,4.34s-3.57,10.79-3.92,18.76C404.1,189,401.87,207.92,403.89,213.75Zm22.19-20.36c-.56,21.41-.32,25.47-.06,27.22,0,0,15,1.45,20-6.37,1.7-3.53-.23-11.69-.64-19.33l2.31-26.12a8.47,8.47,0,0,0-4.88-8.42l-11.06-1.44c-.93,2.16-3,5-4,9.21C426.49,173.56,426.4,181.35,426.08,193.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.71 191.03 404.41 193.07 410.02 227.2 381.86 224.52 374.71 191.03",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.71 191.03 404.41 193.07 410.02 227.2 381.86 224.52 374.71 191.03",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.75,213.12c-.18.68.27,1.65,1.62,2.8,1.09.93,1.8,2.55,3.66,3,3.78.92,5.69.39,5.69.39l-.76-4.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13,194.58s-.07-.47-.15-1.05,1.71-.94,4-.79l4.38.29c2.29.14,4.21.74,4.29,1.32l.14,1.05Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,190.82c-.05-.36.68-.6,1.64-.52l1.73.14s-.31-2.28,3.55-2.17,4.47,2.66,4.47,2.66l1.84.16c1,.09,1.92.46,2,.81l.16.64-15.3-1S381.46,191.18,381.41,190.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.46,191.61c1.4.07,2,.14,2.11,1s.17,1.79.17,1.79l6.77.47s-.21-1.29-.27-1.8.21-.87,1.29-.79l.13-.44L383,191.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.93,194.72s-.07-.47-.15-1.05,1.71-.94,4-.79l4.38.28c2.29.15,4.21.74,4.29,1.33l.15,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3,204.57c2.11.11,5.35.84,7.16,1.13a8.89,8.89,0,0,0,2.86.15,13.39,13.39,0,0,0,2.27-.44c2.6-1.19,23.32-9.67,23.32-9.67l-3.52-20.39s-.83-13.1,4.89-14.48c4.4,2,5.8,5.88,7.82,14.5,2.32,9.86,4.09,21.38,3.18,24.51-.62,2.14-.74,4.45-5.55,6.31-5.08,2-10.76,3.3-27.49,8.1a85.29,85.29,0,0,1-9.61,2.75c-8.54,1.33-11.94-.22-13.64-3.52-.49-1-.57-2-1-3a6.69,6.69,0,0,1-.7-1.63,1.26,1.26,0,0,1,.71-1.46,1.72,1.72,0,0,1,.81,0c1.36.26,2.71.52,4.06.71a26.32,26.32,0,0,0,4.69.16.51.51,0,0,0,.24,0c.23-.1.17-.19,0-.27",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.83,160.37c4,.5,6.58,3.83,7.42,7.75,1.31,6.15,1.93,9.68,3.45,17.49,1.39,7.08,1.92,15.16,1,17.37s-5.41,3.67-8.25,4.51c-4.24,1.26-16.86,4.4-16.86,4.4.09-3-1.6-8-4.19-9.8L441.36,195l-4.08-18.08S435.5,163.77,442.83,160.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.44,202.09s2.16.81,3.58,4.53.61,5.27.61,5.27L422,214.06s.43-6-2.89-9.09Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.62,314.27s-2-28.86-.46-39.71c1.28-9.32,2.78-13.18,3.05-15.3,0,0,2.3-21.89,2.49-40.49.09-9,.92-15.33,5.82-26l30.84,7c.64,4.73,3.52,36.72,4,64.68.45,24.48-.24,45.91-.24,45.91l0,1.28c0,1.43.32,2.43,1.24,4.73a27.65,27.65,0,0,0,4.88,8.08c.65.71,5.15,4.64,5.75,5.48,1.93,2.26-2.08,3.53-5,3.13-3.14-.42-8-1.61-9.39-3.52-.92-1.27-1.61-5.73-2.56-7-3.19-4.36-4.5-6.23-4.53-7.62,0-2.51.83-3.5,1.13-4.92-.25-3-6.65-27.35-6.76-36-.06-4.11.22-9.78.22-9.78l-5-28.49c-1.91,7.11-5.39,20.38-6.53,27.16-1.38,8.29-6.09,32.41-9.05,43.38a57.24,57.24,0,0,0-2,8.65s-.09,1-.09,1c-.07,1.23-.6,14.32-1.09,17.09-1,5.77-6.14,5-7,.37-.7-4,.18-16.26.2-17.77Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,314.27c-1.45,0-.5,5.62-.87,9.23-.4,3.86-1.67,6.68-2,9.84a12.86,12.86,0,0,0,1.21,8.11c1,2.31,6.08,5.48,8,2.17a18.54,18.54,0,0,0,2.12-10.68c-.23-3.73-.45-6.45-.53-9.28-.06-2.5,1.86-8.36,0-8.72l-.09,1c-.67,1.35-7.09,2.28-7.85-.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.15,318c-.44,1.81,0,6.75,0,6.75a6.59,6.59,0,0,0,3.56,2.85L94,320.69Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "92.73 327.57 98.87 325.55 100.35 320.11 93.45 323.6 92.73 327.57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,311.67l0-1.28c.83.4,2.66,7.12,5.14,11.72,2.27,4.21,6.76,6.55,8.22,8.38,1.95,2.45-1.84,5.6-7.93,4.3-3-.64-7.59-2.58-8.83-4.61s-1.65-5.78-2.67-7.28-3.42-3.22-3.93-4.93a9.24,9.24,0,0,1,0-4.7c.48-1.55.89-3.43,1.42-3.26l0,1.18c.41.83,1.88,1.79,4.95,2C97,313.23,98.44,313,99.11,311.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,196s3.77,27.15,4.44,47.66.08,46.95.08,46.95-2.12,1.51-6.78,1.72-6.27-1.35-6.27-1.35-2.85-9.29-3.29-15.82a66.17,66.17,0,0,1,0-10.64L79,237.12S73.53,262.71,72.93,266s-6.34,27.21-6.34,27.21A11,11,0,0,1,59,295c-4.46-.59-6.3-2.73-6.3-2.73s-.92-12.31-.06-18.9,2.63-11.65,2.94-16-.31-27.66,0-37,1.36-16.58,8.36-29.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,237.12,82.47,220s6-1.58,8.85-5.26c0,0-.78,4.08-7,6.7L80.65,238.5l1.25,17.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.73,157.56c7.34,3.62,15.47,8.65,19.47,9.36,5.79-1.14,18.41-4.57,22.76-6.95a3.61,3.61,0,0,0,1.65-1.92c.82-2.16,1.91-3.21,3.14-5,1-1.38,1.29-2.83,1.7-2.77a2.11,2.11,0,0,1,1.38,2.36,17.4,17.4,0,0,1-1,3.78,22.51,22.51,0,0,0,5.22-4.38c2.78-3.41,5.61-2.94,6,2.49.14,1.95.07,6.1-7,10.36-2,1.23-6.56,3.46-9.32,4.69-7.36,3.28-15.62,6.25-20.93,8.12a13.9,13.9,0,0,1-6.37.15c-13.41-3-22.4-7.8-29.56-10.87l.24-12.26C92.54,154.92,94.41,154.44,100.73,157.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,154.74c5.2-.79,10.11,1.1,12.61,2.35,7.88,3.94,18.88,9.64,19.09,9.7s6.64-1.27,6.64-1.27.57,6.2,4.14,9.85c0,0-5.48,2.4-7.65,3s-3.09.57-6-.11-20-6.39-20-6.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,154.61,65,155.87c1.6,9.51-2.9,17.88-2.9,17.88l2.81,14.47c-.12,1.72-3.15,5-5.93,11.53,5.21,7,29.1,10.38,37.44,4.26-.81-8-1.19-11.95-1.45-14.45l0-9c10.45-8.58-2.16-21.63-6.8-25.78H83.81Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.81,191.08c1.88-7.33,8.2-20,10.46-25.84,2.59-6.73,7-9.11,11.86-9.18,1.76,2.29,2.51,13.75-2.95,20.31-2.32,4.89-7.62,15.13-7.62,15.13.18,1.32,3.75,14.89,5.82,19.37a3.61,3.61,0,0,0,1.83,1.76c2.15.93,4.67,3.28,6.38,4.61,1.34,1,2.37,1.2,2.28,1.61a1.94,1.94,0,0,1-2.32,1.23,31.24,31.24,0,0,1-4.25-1.72,53.32,53.32,0,0,0,4.25,5.82c2.89,3.34,2.79,6.19-2.83,6.28-4.26.06-6.5-2.33-10.28-9.62-1.08-2.1-2.65-4.89-3.95-7.59-3.28-6.83-3.92-7.44-5.72-11.8C41.94,194.56,41.08,193.91,41.81,191.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.45,155.67c-5.76.48-9.44.65-12.51,5.16S43,185.61,42,188.68s-1.2,4.69,2.67,12.77a23.11,23.11,0,0,0,10.58-3.72l-1.07-6.17L61.81,177A32.79,32.79,0,0,0,66.45,155.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,151.53c0-1.54-5.12-5.21-7.68-9.1-2.38-3.6-5.71-13.51,2.17-16.67a7,7,0,0,1,0-3.21,6.18,6.18,0,0,1,2.12-3.18,13.57,13.57,0,0,1,6-2.7,32.86,32.86,0,0,1,9.84-.77,18.16,18.16,0,0,1,6.26,1.4,9.57,9.57,0,0,1,4.67,4.27,6.71,6.71,0,0,1,.4,5.14c-.36,1-.4.9.2,1.73a3,3,0,0,1,.59,2.19c-.23,1.69-1.84,2.11-2,3a.82.82,0,0,0,1.41.73,1.69,1.69,0,0,1-2,1.35c-1.82-.1-3.44-2.57-3.44-2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26,123.88c-3.05-1.77-7.65-2.57-11.31,1-4.83,4.71-3.35,16.14-6,20.33-2.43,3.85-5.27,2.44-7.54,5.51a4.26,4.26,0,0,0,1.21,5.83c2.35,1.65,7.39,2.35,11.77-.67,7.37-5.08,5.79-12.26,4.6-17.44s0-14.09,7.27-11.1C68.26,127.34,71.13,125.53,68.26,123.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.48,125.26c2.33,1,4.54,4.57,4.51,14.54,0,8.46-2.62,10.6-3.93,11.22s-3.86.31-6.35-.07v4.86s6,6.58,2,9.36C76.28,163.35,74,155.54,74,155.54l-.18-10.6s-1.43,1.5-4-.7c-2.07-1.82-2.82-4.94-1.26-6.65s3.56-1.85,5.37.06c0,0,3.78.52,8.77-2.61S90,128.5,90.48,125.26Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,136.93a1.12,1.12,0,1,0,1.16-1.12A1.13,1.13,0,0,0,90.7,136.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,137.43a1.21,1.21,0,1,0,2.41.09,1.21,1.21,0,1,0-2.41-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.51,144.51l3.41,1.06a1.73,1.73,0,0,1-2.18,1.3A2,2,0,0,1,83.51,144.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,134.85l-2.89-1.15a1.49,1.49,0,0,1,2-.89A1.62,1.62,0,0,1,93.67,134.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,136.28,74,141a2.21,2.21,0,0,0,2.26-2.27A2.43,2.43,0,0,0,74,136.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.92 136.29 87.83 143.16 90.89 141.67 86.92 136.29",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,151c-2.62-.3-8-1.81-8.89-4a5.72,5.72,0,0,0,1.93,2.78c1.63,1.4,7,2.86,7,2.86Z",
    style: {
      fill: "#f28f8f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoskillset);
export default __webpack_public_path__ + "static/media/noskillset.f4ed7a3e9a2a34de2b069c18a7bef79f.svg";
export { ForwardRef as ReactComponent };